interface ValidationMessages {
  passwordRequired?: string;
  passwordInvalid?: string;
}

export const validatePassword = (
  value: string | undefined,
  messages: ValidationMessages,
): string | true => {
  if (!value || value.trim() === "") {
    return messages?.passwordRequired || "Password is required";
  }

  const hasMinLength = value.length >= 8;
  const hasLetter = /[a-zA-Z]/.test(value);
  const hasNumber = /\d/.test(value);
  const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(value);

  if (!hasMinLength || !hasLetter || !hasNumber || !hasSymbol) {
    return messages?.passwordInvalid || "Password does not meet requirements";
  }

  return true;
};

export const getPasswordInputClasses = (
  hasError: boolean,
  hasValue: boolean,
): string => {
  if (hasError) {
    return "bg-primary border-danger focus:bg-primary focus:border-danger";
  }
  if (hasValue) {
    return "bg-primary border-primary";
  }
  return "bg-accent border-transparent";
};
